import React, { PureComponent } from 'react'
import { string, object, shape } from 'prop-types'
import { Text, SvgGrid, PreSeasonPerformanceLine } from 'components'
import ITEM from 'utils/constants/items'
import { translate } from 'react-i18next'
import { capitalize } from 'utils/string'
import { max } from 'lodash'

const svgViewBox = '0 0 215 110'
const viewBox = { x: 28.3, y: 0.5, width: 186.2, height: 97.1 }

@translate()
export class PanelAMToolLineChart extends PureComponent {
    static propTypes = {
        data: object.isRequired,
        selectedGroupId: string,
        selection: object.isRequired,
        curvesParams: shape({
            engine: object.isRequired,
            gearbox: object.isRequired,
            wheels: object.isRequired
        }).isRequired,
        typeSelected: string
    }

    componentWillMount() {
        const { data } = this.props
        const enginePerformanceMax = max(data[ITEM.PRE_SEASON_ENGINE].options.map(o => o.performanceMax)) * 1.1
        const gearboxPerformanceMax = max(data[ITEM.PRE_SEASON_GEARBOX].options.map(o => o.performanceMax)) * 1.1
        const wheelsPerformanceMax = max(data[ITEM.PRE_SEASON_WHEELS].options.map(o => o.performanceMax)) * 1.1
        const engineExpectedAssetLife = max(data[ITEM.PRE_SEASON_ENGINE].options.map(o => o.expectedAssetLife)) * 1.1
        const gearboxExpectedAssetLife = max(data[ITEM.PRE_SEASON_GEARBOX].options.map(o => o.expectedAssetLife)) * 1.1
        const wheelsExpectedAssetLife = max(data[ITEM.PRE_SEASON_WHEELS].options.map(o => o.expectedAssetLife)) * 1.1
        this.factorsOptions = [0, 1, 2].map(i => ({
            engine: {
                x: data[ITEM.PRE_SEASON_ENGINE].options[i].expectedAssetLife / engineExpectedAssetLife,
                y: data[ITEM.PRE_SEASON_ENGINE].options[i].performanceMax / enginePerformanceMax
            },
            gearbox: {
                x: data[ITEM.PRE_SEASON_GEARBOX].options[i].expectedAssetLife / gearboxExpectedAssetLife,
                y: data[ITEM.PRE_SEASON_GEARBOX].options[i].performanceMax / gearboxPerformanceMax
            },
            wheels: {
                x: data[ITEM.PRE_SEASON_WHEELS].options[i].expectedAssetLife / wheelsExpectedAssetLife,
                y: data[ITEM.PRE_SEASON_WHEELS].options[i].performanceMax / wheelsPerformanceMax
            }
        }))
    }

    renderLineForOption = i => {
        const { data, curvesParams, typeSelected, selectedGroupId, selection } = this.props
        const selectedItem = (selection[selectedGroupId] || {}).type
        const selectedItemIndex = data[selectedGroupId].options.map(o => o.id).indexOf(selectedItem)
        return (
            <PreSeasonPerformanceLine
                key={i}
                className={{ Selected: selectedItemIndex === i, NotSelected: selectedItemIndex >= 0 && selectedItemIndex !== i }}
                curvesParams={curvesParams}
                typeSelected={typeSelected}
                outputViewBox={viewBox}
                factors={this.factorsOptions[i]}
                clipPath="url(#viewBoxClip)"
            />
        )
    }
    render() {
        const { selectedGroupId, typeSelected, width, height, className, t } = this.props
        if (selectedGroupId && typeSelected) {
            const itemName = capitalize(typeSelected)
            return (
                <div className={['Panel-Chart Line', className]}>
                    <Text className="ChartLegend Y">{t('game.PRE_SEASON.panelAMToolLineChartYLabel', { name: itemName })}</Text>
                    <svg width={width} height={height} viewBox={svgViewBox}>
                        <SvgGrid viewBox={viewBox} zeroLabel="0%" xLabel="100%" yLabel="100%" clipId="viewBoxClip" />
                        {[0, 1, 2].map(this.renderLineForOption)}
                    </svg>
                    <Text className="ChartLegend X">{t('game.PRE_SEASON.panelAMToolLineChartXLabel', { name: itemName })}</Text>
                </div>
            )
        }
        return null
    }
}



// WEBPACK FOOTER //
// src/components/Panel/PanelAMToolLineChart.js